// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSwapLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PSwapLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PSwapLeftOutlined = function PSwapLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSwapLeftOutlinedSvg
  }));
};

PSwapLeftOutlined.displayName = 'PSwapLeftOutlined';
export default React.forwardRef(PSwapLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSwapLeftOutlined.js
// module id = 3668
// module chunks = 0